import React from 'react';
import '../App.css';

const challenges = [
  '患者管理效率低：院外、术后、慢病患者随访耗费大量人力，流程繁琐，难以形成标准化和持续的机制。',
  '数据整合困难：以患者为中心的诊断、影像、检验、健康数据分散在不同机构和系统，无法形成统一视图，决策支持不足。',
  '服务模式单一：传统医疗服务难以满足患者个性化、连续性的健康管理需求，患者体验欠佳。',
  '跨机构协作不畅：跨机构、跨院区、跨部门、医联体单位协作流程复杂，资源无法高效共享。',
  '科研转化周期长：临床数据收集、整理、分析流程原始，阻碍了专病研究和AI技术的有效应用。',
];

function Challenge() {
  return (
    <section className="challenge-section">
      <h2 className="challenge-title">您是否正面临现代医疗管理的多重挑战?</h2>
      <div className="challenge-card">
        {challenges.map((item, idx) => {
          const splitIdx = item.indexOf('：');
          const before = splitIdx !== -1 ? item.slice(0, splitIdx + 1) : item;
          const after = splitIdx !== -1 ? item.slice(splitIdx + 1) : '';
          return (
            <div className="challenge-item" key={idx}>
              <span className="challenge-index">{idx + 1}</span>
              <span className="challenge-text">
                <b style={{fontWeight: 700}}>{before}</b>{after}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
export default Challenge; 